import { render, staticRenderFns } from "./LearningObject.vue?vue&type=template&id=0d49f213"
import script from "./LearningObject.vue?vue&type=script&lang=js"
export * from "./LearningObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports